import { Alert, Button, Card, DatePicker, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { useSelector } from "react-redux";
import config from "../../config";
import Reports from "./reports";
import ProfitAndLoss from "./profitAndLoss";
import * as XLSX from "xlsx";
import { useAccess } from "../../provider/AccessProvider";
import { REPORTACCESS } from "../../utils/constant";
import { useHotkeys } from "react-hotkeys-hook";

const { RangePicker } = DatePicker;

const ReportProfitAndLoss = ({
  tab,
  setTotalSales = () => {},
  totalSales = 0,
}) => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const [billList, setBillList] = useState([]);
  const [dates, setDates] = useState([dayjs(), dayjs()]);
  const [value, setValue] = useState([dayjs(), dayjs()]);
  const [viewTrigger, setViewTrigger] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [employeeArr, setEmployeeArr] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [csvLoader, setCsvLoader] = useState(false);
  const [profitLossExport, setProfitLossExport] = useState({
    billLevel: [],
    productLevel: [],
  });
  const [expensesList, setExpensesList] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const access = useAccess(REPORTACCESS);

  const fetchEmployee = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          method: "post",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            action: "fetchEmployee",
          }),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": `${config.newApiKey}`,
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        setEmployeeArr(res.data);
      } else {
        // alert(res.message);
      }
    } catch (err) {
      console.error("err", err);
    }
  };

  const fetchExpenses = async (fromDate, toDate) => {
    try {
      let res = await fetch(`${config.newApiGateway}/expenses/expenses`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopDetails.shopId,
          from: fromDate,
          to: toDate,
          employeeId: selectedEmployee ? selectedEmployee : "",
        }),
      });
      res = await res.json();

      if (res.code === "SUCCESS") {
        const result = res.data.map((i) => {
          const type = shopDetails.expensesType?.find(
            (item) => item.expensesTypeId === i.expenseType
          );
          return {
            ...i,
            expenseTypeName: type ? type.expensesTypeName : "",
          };
        });
        setExpensesList(result);

        // Calculate total expenses
        const total = result.reduce((acc, cur) => {
          return acc + parseFloat(cur.expenseAmount || 0);
        }, 0);
        setTotalExpenses(total);
      }
    } catch (err) {
      console.error("Error fetching expenses:", err);
    }
  };

  const b2bBills = useMemo(() => {
    const b2b = billList.filter((bill) => {
      return bill.b2bBill;
    });

    return b2b;
  }, [billList]);

  const salesReportBillB2c = useMemo(() => {
    const data = billList.filter((bill) => {
      return !bill.b2bBill;
    });

    return data;
  }, [billList]);

  console.log("b2bBills2323", b2bBills);

  const fetchSalesReport = async (payload, fromDate, toDate) => {
    try {
      let res = await fetch(
        `${config.newApiGateway}/analytics/getSalesReports`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            from: fromDate,
            to: toDate,
            // employeeId: shopDetails.empId ? shopDetails.empId : "",
            employeeId:
              shopDetails.userType === "Employee"
                ? shopDetails.empId
                : selectedEmployee
                ? selectedEmployee
                : "",
            lastItem: undefined,
            ...payload,
          }),
        }
      );
      res = await res.json();
      setBillList((prev) => {
        return [...prev, ...res.bills];
      });
      return res;
    } catch (err) {
      console.error("fetchSalesReport", err);
    }
  };

  const getSalesReports = async (fromDate, toDate) => {
    try {
      setBillList([]);
      let res = await fetchSalesReport(null, fromDate, toDate);
      console.log("response", res);
      while (res.lastItem) {
        const nextRespones = await fetchSalesReport(
          { lastItem: res.lastItem },
          fromDate,
          toDate
        );
        res = nextRespones;
      }

      // Fetch expenses for the same date range
      await fetchExpenses(fromDate, toDate);
    } catch (err) {
      console.error("getSalesReports", err);
    } finally {
      setViewTrigger(false);
      setIsLoading(false);
    }
  };

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate =
      (dates[0] && current.diff(dates[0], "days") > 30) || current > dayjs();
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 30;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const getCustomerReport = async () => {
    setCsvLoader(true);
    // setViewTrigger(true);
    const fromDate =
      (dates && dates[0].format("YYYY-MM-DD")) ||
      (value && value[0].format("YYYY-MM-DD"));
    const toDate =
      (dates && dates[1].format("YYYY-MM-DD")) ||
      (value && value[1].format("YYYY-MM-DD"));
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/generateCustomerBillReport`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            from: fromDate,
            to: toDate,
            employeeId: selectedEmployee ? selectedEmployee : "",
          }),
        }
      );
      res = await res.json();
      if (res.code === "ERROR") {
        setCsvLoader(false);
        alert(res.message);
        return;
      }
      window.open(res.data);
      setCsvLoader(false);
    } catch (err) {
      setCsvLoader(false);
      alert("Error while generating report. Please try again.");
    }
  };
  const getCustomerReportB2b = async () => {
    setCsvLoader(true);
    // setViewTrigger(true);
    const fromDate =
      (dates && dates[0].format("YYYY-MM-DD")) ||
      (value && value[0].format("YYYY-MM-DD"));
    const toDate =
      (dates && dates[1].format("YYYY-MM-DD")) ||
      (value && value[1].format("YYYY-MM-DD"));
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/generateCustomerBillReport`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            from: fromDate,
            to: toDate,
            b2b: true,
            employeeId: selectedEmployee ? selectedEmployee : "",
          }),
        }
      );
      res = await res.json();
      if (res.code === "ERROR") {
        setCsvLoader(false);
        alert(res.message);
        return;
      }
      window.open(res.data);
      setCsvLoader(false);
    } catch (err) {
      setCsvLoader(false);
      alert("Error while generating report. Please try again.");
    }
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      fetchEmployee();
    }
  }, [shopDetails.shopId]);

  useEffect(() => {
    if (shopDetails.shopId && viewTrigger) {
      if (!value) {
        return alert("Please select date");
      }
      setBillList([]);
      const fromDate =
        (dates && dates[0].format("YYYY-MM-DD")) ||
        (value && value[0].format("YYYY-MM-DD"));
      const toDate =
        (dates && dates[1].format("YYYY-MM-DD")) ||
        (value && value[1].format("YYYY-MM-DD"));

      console.log("fromDate", fromDate, toDate);
      getSalesReports(fromDate, toDate);
    }
  }, [viewTrigger, shopDetails.shopId]);

  const handleProfitAndLossDownload = () => {
    const filterBillLevel = profitLossExport.billLevel.map((x) => {
      return {
        "Invoice Number": x.invoicePrefix + " " + x.invoiceNumber,
        "Customer Name": x.customerName,
        "Customer Phone Number": x.customerPhoneNumber,
        "Bill Amount": x.amountPaid,
        Discount: x.discountAmount,
        Tax: x.taxAmount,
        Profit: x.profit,
        Loss: x.loss,
      };
    });
    const filterProductLevel = profitLossExport.productLevel.map((x) => {
      return {
        "Product Name": x.productName,
        "Selling Price": x.averageProductPrice,
        "Purchase Price": x.averagePurchasePrice,
        Quantity: x.totalQuantity,
        Discount: x.discountAmount,
        Tax: x.taxAmount,
        Profit: x.profit,
        Loss: x.loss,
      };
    });
    const ws = XLSX.utils.json_to_sheet(filterProductLevel);
    const ws2 = XLSX.utils.json_to_sheet(filterBillLevel);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Product Level");
    XLSX.utils.book_append_sheet(wb, ws2, "Bill Level");
    XLSX.writeFile(wb, "profit&Loss-Report.xlsx");
  };

  return (
    <div>
      {!access.salesReport(false) || !access.profitAndLoss(false) ? null : (
        <Card id="report-card">
          <div
            style={{
              width: 400,
              display: "inline-block",
            }}
          >
            {console.log("RangePicker1212", dates || value)}
            <RangePicker
              //value={dates || value}
              style={{
                width: "400px",
              }}
              size="medium"
              disabledDate={disabledDate}
              onCalendarChange={(val) => setDates(val)}
              onChange={(val) => setValue(val)}
              onOpenChange={onOpenChange}
            />
          </div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <Select
              style={{
                width: 150,
              }}
              onChange={(value) => {
                if (value === "All Employees") {
                  setSelectedEmployee("");
                } else {
                  setSelectedEmployee(value);
                }
              }}
              value={selectedEmployee}
              allowClear
              disabled={shopDetails.userType === "Employee"}
              placeholder="All Employees"
            >
              {employeeArr.map((data) => (
                <Select.Option key={data.userId} value={data.userId}>
                  {data.userName}{" "}
                </Select.Option>
              ))}
            </Select>
          </div>
          <Button
            onClick={() => {
              setViewTrigger(true);
            }}
            type="primary"
            ghost
            size="medium"
            disabled={isLoading}
          >
            View
          </Button>
          {tab === "reports" && (
            <Button
              type="primary"
              size="medium"
              disabled={csvLoader}
              onClick={getCustomerReport}
              style={{
                paddingLeft: 8,
                paddingRight: 8,
              }}
              id="reportDownloadBtn"
            >
              {csvLoader ? (
                <>
                  Generating...{" "}
                  <Spinner variant="danger" animation="border" size="sm" />
                </>
              ) : (
                <FiDownload
                  size={20}
                  style={{
                    margin: 0,
                  }}
                />
              )}
            </Button>
          )}
          {tab === "b2bSalesReport" && (
            <Button
              type="primary"
              size="medium"
              disabled={csvLoader}
              onClick={getCustomerReportB2b}
              style={{
                paddingLeft: 8,
                paddingRight: 8,
              }}
              id="reportDownloadBtn"
            >
              {csvLoader ? (
                <>
                  Generating...{" "}
                  <Spinner variant="danger" animation="border" size="sm" />
                </>
              ) : (
                <FiDownload
                  size={20}
                  style={{
                    margin: 0,
                  }}
                />
              )}
            </Button>
          )}

          {tab === "profitAndLoss" && (
            <Button
              type="primary"
              size="medium"
              onClick={handleProfitAndLossDownload}
              style={{
                paddingLeft: 8,
                paddingRight: 8,
              }}
            >
              {csvLoader ? (
                <>
                  Generating...{" "}
                  <Spinner variant="danger" animation="border" size="sm" />
                </>
              ) : (
                <FiDownload
                  size={20}
                  style={{
                    margin: 0,
                  }}
                />
              )}
            </Button>
          )}
        </Card>
      )}

      {tab === "reports" && (
        <>
          {!access.salesReport(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
                marginTop: 20,
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <Reports
              setTotalSalesValue={(v) => {
                setTotalSales(v);
              }}
              billList={salesReportBillB2c}
              isLoading={isLoading}
              totalExpenses={totalExpenses}
              expensesList={expensesList}
            />
          )}
        </>
      )}

      {tab === "b2bSalesReport" && (
        <>
          {!access.salesReport(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
                marginTop: 20,
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <Reports
              setTotalSalesValue={(v) => {
                setTotalSales(v);
              }}
              billList={b2bBills}
              isLoading={isLoading}
              totalExpenses={totalExpenses}
              expensesList={expensesList}
            />
          )}
        </>
      )}

      {tab === "profitAndLoss" && (
        <>
          {!access.profitAndLoss(false) ? (
            <Alert
              style={{
                padding: "20px",
                marginTop: 20,
                textAlign: "center",
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <ProfitAndLoss
              totalSales={totalSales}
              billList={billList}
              date={dates}
              selectedEmployee={selectedEmployee}
              isLoading={isLoading}
              onSetExportBillLevel={(array) => {
                setProfitLossExport((prev) => ({
                  ...prev,
                  billLevel: array,
                }));
              }}
              onSetExportProfitLoss={(array) => {
                setProfitLossExport((prev) => ({
                  ...prev,
                  productLevel: array,
                }));
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ReportProfitAndLoss;
